/* utm-al-pedido.js — guarda el anuncio que trajo la visita como dato del pedido.
 *
 * POR QUÉ EXISTE
 * Shopify sólo guarda el recorrido del cliente — y con él la UTM del anuncio —
 * cuando el visitante acepta las cookies de analítica. Medido el 20-ago-2026:
 * en Alemania eso dejaba el 30% de los pedidos sin ningún origen, contra el 1%
 * en Estados Unidos. Este script no depende de esa cookie: lee la UTM de la
 * barra de direcciones al cargar y la escribe en el carrito, que es el mismo
 * carrito con el que se paga, así que llega al pedido.
 *
 * REGLAS DE LA CASA (versión sin riesgo, elegida por Nati el 20-ago-2026)
 *  - NO TOCA EL BOTÓN DE COMPRAR. Ni un listener de clic, ni un preventDefault,
 *    ni nada que pueda demorar o interceptar una compra. Es imposible que este
 *    archivo cueste una venta.
 *    El precio de esa garantía: si alguien apretara COMPRAR antes de que
 *    termine el guardado (~200 ms), ese pedido queda sin etiqueta. Son poquitos
 *    y se prefiere perderlos antes que tocar el botón.
 *  - No guarda nada en el navegador: ni cookies, ni localStorage, ni sessionStorage.
 *  - Los atributos llevan guión bajo adelante: no se le muestran al comprador
 *    en el mail ni en la página de gracias, pero sí se leen por API.
 */
(function () {
  'use strict';

  var CLAVES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var TOPE = 255; // Shopify recorta los atributos largos igual

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }

  var attrs = {};
  var hay = false;
  for (var i = 0; i < CLAVES.length; i++) {
    var v = params.get(CLAVES[i]);
    if (v) { attrs['_' + CLAVES[i]] = String(v).slice(0, TOPE); hay = true; }
  }
  if (!hay) return; // sin anuncio no hay nada que hacer: el script se apaga solo

  // Mismo prefijo de idioma que la página actual: si estamos en /de/... se
  // escribe en /de/cart. A propósito NO se usan los helpers de rutas de
  // Shopify, que mandan al mercado equivocado (lección del botón por idioma).
  var m = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i);
  var base = m ? m[1] : '';

  // Una sola llamada, sin await, sin bloquear nada. Si falla, falla en silencio.
  try {
    fetch(base + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      credentials: 'same-origin',
      keepalive: true
    }).catch(function () {});
  } catch (e) { /* nunca romper la página */ }
})();
